var parallaxCapa = (function(){
	$(window).scroll(function(){
		var st = $(window).scrollTop();
		var fxH = $('.faixa-topo').outerHeight();

		if(st > fxH){
			$('.capa').css('background-position', 'center '+((st - fxH)/2)+'px')
		}else{
			$('.capa').css('background-position', 'center top')
		}
	});
})();